import { useCallback, useRef, useState } from 'react';

// Ignora novos envios enquanto o anterior está em andamento (duplo clique).
// O ref bloqueia de forma síncrona; o estado serve para desabilitar o botão.
export function useSubmitLock() {
  const lockedRef = useRef(false);
  const [submitting, setSubmitting] = useState(false);

  const runLocked = useCallback(async (action) => {
    if (lockedRef.current) return undefined;
    lockedRef.current = true;
    setSubmitting(true);
    try {
      return await action();
    } finally {
      lockedRef.current = false;
      setSubmitting(false);
    }
  }, []);

  return [submitting, runLocked];
}
